import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Group 4841",
  "use": "icon-Group 4841-usage",
  "viewBox": "0 0 75 29.915",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 75 29.915\" id=\"icon-Group 4841\">\n  <g id=\"icon-Group 4841_Group_4841\" data-name=\"Group 4841\" transform=\"translate(-923 -5854.085)\">\n    <path id=\"icon-Group 4841_Path_2482\" data-name=\"Path 2482\" d=\"M298.161,2184.685,288.046,2194.8l10.115,10.115\" transform=\"translate(3154.414 5567.454) rotate(90)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\" />\n    <text id=\"icon-Group 4841_BACK_TO_TOP\" data-name=\"BACK TO TOP\" transform=\"translate(998 5880)\" fill=\"#fff\" font-size=\"12\" font-family=\"NotoSansCJKtc-Regular, Noto Sans CJK TC\"><tspan x=\"-74.94\" y=\"0\">BACK TO TOP</tspan></text>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Group 4841.svg
// module id = Hxm1
// module chunks = 3